import { types } from "./types";

export const setToken = (token, expireAt) => ({
  type: types.SET_TOKEN,
  payload: { token, expireAt }
});

export const deleteToken = () => ({
  type: types.DELETE_TOKEN
});
export const setIsTokenExpired = isAccessTokenExpired => ({
  type: types.SET_IS_TOKEN_EXPIRED,
  payload: isAccessTokenExpired
});
